export default __webpack_public_path__ + "static/media/searchIconImg.0e09fcc9.svg";